// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./font/Inter-VariableFont_slnt,wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./images/RectangleCopy.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./images/HodDashboard1.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./images/HodDashboard2.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./images/HodDashboard3.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./images/HodDashboard4.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./images/AdminDashboardLogo1.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./images/AdminDashboardLogo2.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./images/AdminDashboardLogo3.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./images/AdminDashboardLogo4.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./images/pink.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("./images/purple.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("./images/blue-star.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("./images/green-star.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: Inter;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.ds-dropdown {
  background: #475BE8;
}

.btn {
  color: #fff;
}

.ps-heading {
  color: #292929;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 131.9%;
}

.ps-project-name {
  color: #525252;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 131.9%;
}

.nav-logo {
  color: white;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: 131.9%;
}

/* the Gantt chart bar label */
._3zRJQ {
  font-size: 0px !important;
}
._WuQ0f:first-child{
  padding-left: 10px;
}
._nI1Xw div{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.task_name{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 200px !important;
}

.login_container {
  display: flex;
  height: 100vh;
  align-items: center;
  justify-content: center;
  width: 100%;
  /* overflow: hidden; */
}



.head {
  color: #03030A;
  font-size: 24px !important;
  font-weight: 600;
  font-family: Inter;
}




.content {
  padding-top: 17px !important;

}

.text-900 {
  font-size: 13px !important;
  font-weight: 500 !important;
  font-family: Inter !important;
}

.text-800 {
  font-size: 13px !important;
  font-weight: 500 !important;
  font-family: Inter !important;
  color: #03030A !important;
  line-height: 15.73px;
  letter-spacing: 0.01px;
}

.l-forget-text {
  font-family: Inter !important;
  font-family: 500 !important;
  font-size: 12px !important;
  color: #03030A !important;
}

.ls-admin_bg {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  width: 100%;
  height: 100%;
  /* padding: 47px 0 47px 88px; */
  background-repeat: no-repeat;
  background-size: cover !important;
  border-radius: 12px;
}

.ls-yellow_bg {
  /* background: url(./images/RectangleColor.png); */
  width: 100%;
  height: 100%;
}

.ls-text {
  color: #03030A;
  font-family: Inter;
  font-size: 44px;
  font-weight: 300;
  font-style: normal;
  line-height: 56px;
  /* 127.273% */
  letter-spacing: 0.44px;
}

.ls-subtext {
  color: #03030A;
  font-family: Inter;
  font-size: 44px;
  font-weight: 600;
  font-style: normal;
  line-height: 56px;
  /* 127.273% */
  letter-spacing: 0.44px;
}




.field {
  display: flex;
  align-items: center;
}



.register .input_field {
  height: 35px;
}

.error_msg p {
  color: #bf1650;
  font-size: 10px;
  font-weight: 500;
  margin: -8px 0 1rem 0;
  line-height: 1.5;
  font-family: AppleSDGothicNeo-Regular;

}


.login_error_msg p {
  color: #E40000;
  font-size: 12px;
  font-weight: 500;
  margin: -8px 0 1rem 0;
  line-height: 14.52px;
  font-family: AppleSDGothicNeo-Regular;

}

.error_msg p::before {
  display: inline;
  content: "⚠ ";
}

.error_msg_RA {
  color: #bf1650;
  font-size: 10px;
  font-weight: 500;
  padding-top: 10px;
}

.error_msg_RA::before {
  display: inline;
  content: "⚠ ";
}




.hod-dash-image{
  width: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-position: right;
}
.hod-dash2-image{
  width: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-repeat: no-repeat;
  background-position: right;
}
.hod-dash3-image{
  width: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-repeat: no-repeat;
  background-position: right;
}
.hod-dash4-image{
  width: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-repeat: no-repeat;
  background-position: right;
}

.admin-dash-image{
  width: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-repeat: no-repeat;
  background-position: right;
  background-size: cover;
}
.admin-dash2-image{
  width: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-repeat: no-repeat;
  background-position: right;
  background-size: cover;
}
.admin-dash3-image{
  width: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-repeat: no-repeat;
  background-position: right;
  background-size: cover;
}
.admin-dash4-image{
  width: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-repeat: no-repeat;
  background-position: right;
  background-size: cover;
}

/* .admin-dash1-image{
  width: 100%;
  background-image: url(./images/projects/admindash1.png);
  background-repeat: no-repeat; 
  background-size: contain;
  flex: 1;
  min-height: 100px;
}
.dash-container {
  display: flex;
  flex-direction: column;
  align-items: center; 
  gap: 1rem; 
  height: auto;
} */

.p-dropdown .p-dropdown-label.p-placeholder {
  color: #4b5563;
  font-size: 1rem;
}

.login-btn {
  color: #FFFFFF;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 131.9%;
  border-radius: 5px;
  background: #014FA0;
  padding: 10px;
  border: 1px solid #014FA0;
}
/* .p-button :hover{
  color: #FFFFFF !important;
} */

.eye-icon-position {
  top: 9px;
  right: 12px;
}

.card {
  background: var(--surface-card);
  border-radius: 8px;
  border: 1px solid #EAEAEA;
  background: #FFF;
  box-shadow: 0 0 0 0 !important;
  padding: 1rem;
}

.dashboard-card {
  background: var(--surface-card);
  border-radius: 8px;
  border: 1px solid #EAEAEA;
  background: rgb(248, 248, 248);
  box-shadow: 0 0 0 0;
  padding: 4px;
  margin-bottom: 10px;
}

.card-title {
  background: #F8F8F8;
}

.card-heading {
  color: #03030A;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.008px;
}

.user-attachment{
  font-size: 14px; 
  font-weight: 600;
  color: #03030A;
  line-height: 16.94px;
  letter-spacing: 0.01px;
  font-family: Inter;
}
.file-upload-size{
  font-size: 12px; 
  font-weight: 400;
  color: #03030A;
  line-height: 14.52px;
  letter-spacing: 0.01px;
  font-family: Inter;
}

.upload-text{
  font-size: 13px !important; 
  font-weight: 400 !important;
  color: #03030A !important;
  line-height: 15.73px !important;
  letter-spacing: 0.01px !important;
  font-family: Inter !important;
}
.btn-yellow {
  border-radius: 5px;
  border: 1px solid #014FA0;
  background: #014FA0;
  color: #FFFFFF;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 16.94px;
  letter-spacing: 0.009px;
  padding: 9px 12px;
  opacity: 1;
}

.btn-yellow:hover, .btn-clear:hover{
  border: solid 1px #014FA0;
  background-color: #014FA0 !important;
  color: #ffffff !important;
}

.btn-clear {
  border-radius: 5px;
  border: 1px solid #014FA0;
  background: #014FA0;
  color: #FFFFFF;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.009px;
  padding: 9px 11px;
}

.btn-black-user {
  border-radius: 5px;
  border: 1px solid #014FA0;
  background: #014FA0;
  color: #FFFFFF;
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: 15.73px;
  letter-spacing: 0.01px;
  padding: 6px 10px;
  height: 28px;
}

.btn-yellow-user {
  border-radius: 5px;
  border: 1px solid #014FA0;
  background: #014FA0;
  color: #FFFFFF;
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: 15.73px;
  letter-spacing: 0.01px;
  padding: 6px 10px;
  height: 29px;
}

.task-status {
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 0.007px;
  padding: 5px 8px;
  border-radius: 5px;
  border: 1px solid transparent;
}

.master-tab-inner {
  padding: 11px 12px 13px;
  background: #F3F3F3;
  border: 1px solid #F3F3F3;
  border-radius: 5px;
  margin-bottom: 20px;
}

.table-wrapper {
  border-radius: 8px !important;
  border: 1px solid #EAEAEA;
  background: #FFFFFF;
}

.header-list {
  color: #03030A;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 0.007px;
}

.lr-gap .field:nth-child(odd) {
  padding-right: 34px;
}

.lr-gap .field:nth-child(even) {
  padding-left: 34px;
}

.card-hover:hover {
  background: #F8F8F8;
}



/* comments section */
.text-13-500 {
  color: #03030A;
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 15.73px;
  letter-spacing: 0.01px;
}

.text-12-400 {
  color: #03030A;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.007px;
}

.comment-lefttext-bg {
  background-color: #F8F8F8;
  padding: 12px 18px;
  width: -moz-fit-content;
  width: fit-content;
  position: relative;
  margin-right: 20px;
}

.comment-lefttext-bg::after {
  content: "";
  position: absolute;
  right: -20px;
  bottom: 0;
  width: 0;
  height: 0;
  border-left: 20px solid #F8F8F8;
  border-top: 20px solid transparent;
  border-bottom: 20px solid transparent;
}

.comment-righttext-bg {
  background-color: #F8F8F8;
  padding: 12px 18px;
  width: -moz-fit-content;
  width: fit-content;
  position: relative;
  margin-left: 20px;
}

.comment-righttext-bg::before {
  content: "";
  position: absolute;
  left: -20px;
  bottom: 0;
  width: 0;
  height: 0;
  border-right: 20px solid #F8F8F8;
  border-top: 20px solid transparent;
  border-bottom: 20px solid transparent;
}

.comment-input {
  background-color: #F8F8F8;
}


@media (max-width: 770px) {
  .lr-gap .field:nth-child(odd) {
    padding: 0;
  }

  .lr-gap .field:nth-child(even) {
    padding: 0;
  }

}
.small-cards{
  margin: 18px 0 18px 23px;
}
.small-text{
  margin: auto;
  margin-left: 14px;

  }
.attendance-download-position {
  position: relative;
}

.attendance-download-btn-position {
  position: absolute;
  top: -120px;
  right: 8px;
}

/* Add this CSS to your stylesheet */
.skill-matrix-table .table-container {
  width: 100%;
  overflow-x: auto;
}

.skill-matrix-table table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #EAEAEA;
}

.skill-matrix-table table th,
.skill-matrix-table table td {
  padding: 8px;
  border: 1px solid #EAEAEA;
  font-family: Inter;
  font-size: 13px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.007389103528112173px;
  text-align: left;
  color: #03030A;

}

.skill-matrix-table table td {
  border-width: 0px 0px;
  text-align: center;
  padding: 16px;
}

.skill-matrix-table table tbody tr {
  border-width: 1px 0px;
  border: 1px solid #EAEAEA;
}

.skill-matrix-table table th {
  text-align: center;
  background-color: #F8F8F8;
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  line-height: 25px;
  letter-spacing: 0.00862062070518732px;
  text-align: center;
  color: #03030A;
}

/* Add this CSS to your stylesheet */
.txt-vertical {
  writing-mode: vertical-rl;
  text-orientation: mixed;
  padding: 8px;
}

.txt-vertical h4 {
  margin: 0;
  transform: rotate(-180deg);
  transform-origin: center;
  font-size: 13px;
  font-weight: 400;
}

.level-1 {
  /* color: #F3C3FF !important; */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.level-2 {
  /* color: #CDC3FF !important; */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.level-3 {
  /* color: #AAC9FF !important; */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.level-4 {
  /* color: #CDF463 !important; */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.fsv-label {
  font-family: Inter;
  font-size: 13px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0.007389103528112173px;
  text-align: left;
  color: #03030A;
}

.fsv-value {
  background-color: #F8F8F8;
  font-family: Inter;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.007389103528112173px;
  text-align: left;
  color: #03030A;
  padding: 10px;
  border-radius: 5px;
}


.event-day {
  background-color: #ffc107;
}
/* Custom styles for FullCalendar */
.fc .fc-toolbar-title{
  font-size: 16px;
}
.fc-scrollgrid-sync-inner{
  padding: 5px 0;
}
.fc-dayGridMonth-view .fc-day-header {
  background-color: #f0f0f0; /* Change day header background color */
  color: #333; /* Change day header text color */
}

.fc-dayGrid-event {
  background-color: #007bff; /* Change event background color */
  color: #fff; /* Change event text color */
  border: 1px solid #007bff; /* Add border to event */
}

.fc-dayGrid-event:hover {
  background-color: #0056b3; /* Change event background color on hover */
}

/* Custom styles for event content */
.PS-card-key {
  cursor: pointer;

  word-wrap: break-word;
  text-wrap: wrap;
  padding: 3px 7px;
}
.fc-h-event{}
.fc-daygrid-event{
  /* border: yellow;
  background-color: yellow; */
  /* margin: 3px 0; */
  border: 0;
}
.EC-card-key h4{
  color: #03030A;
font-family: Inter;
font-size: 14px;
font-style: normal;
font-weight: 500;
line-height: normal;
letter-spacing: 0.007px;
width: 100%;
}
.fc-direction-ltr .fc-daygrid-event.fc-event-end, .fc-direction-rtl .fc-daygrid-event.fc-event-start{
  margin-left: 0;
  margin-right: 0;
}
.fc-direction-ltr .fc-daygrid-event.fc-event-start, .fc-direction-rtl .fc-daygrid-event.fc-event-end{
  margin-left: 0;
  margin-right: 0;
}
.fc-daygrid-dot-event{
  padding: 0px;
}
.fc-daygrid-dot-event.fc-event-mirror, .fc-daygrid-dot-event:hover{
  background-color: transparent;
}
.fc-event-selected, .fc-event:focus{}

/* Add more custom styles as needed */


.d-status .p-dropdown-label.p-placeholder{
  color: black !important;
}

.toggle-switch {
  display: flex;
  background-color: #323232;
  padding: 2px;
  border-radius: 5px;
}

.toggle-button {
  padding: 5px 10px;
  border: 1px solid transparent;
  background-color: transparent;
  cursor: pointer;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0.00862062070518732px;
}

.toggle-button.active {
  background-color: #E6FB2D;
  border-radius: 5px;
  color: #323232;
  font-size: 13px;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0.00862062070518732px;
}

.flex-container {
  display: flex;
  gap: 1rem;
  width: 100%;
}

.p-datatable {
  position: relative;
  border: 1px solid #e5e7eb;
  border-radius: 8px !important;
}

@media (max-width: 768px) {
  .flex-container {
      flex-direction: column; /* Stack elements vertically */
  }
  .project_search{
    display: flex;
    margin-top: 15px;
  }
  .Pro{
    flex-direction: column;
  }
}

.user-dashboard img{
  width: 100%;
  height: 100%;
}
.user-dashboard-title{
  font-size: 16px;
  font-weight: 600;
  line-height: 19.36px;
  letter-spacing: 0.01px;
  color: #03030A;
  font-family: Inter;
}

table .user-project-header{
  font-size: 15px !important;
  font-weight: 500 !important;
  line-height: 18.15px !important;
  letter-spacing: 0.01px !important;
  color: #03030A !important;
  font-family: Inter !important;
}
table .user-project-bodyColumn{
  font-size: 12px !important;
  font-weight: 400 !important;
  line-height: 14.52px !important;
  letter-spacing: 0.01px !important;
  color: #03030A !important;
  font-family: Inter !important;
}
table .admin-project-bodyColumn{
  font-size: 13px !important;
  font-weight: 700 !important;
  line-height: 15.73px !important;
  letter-spacing: 0.01px !important;
  color: #03030A !important;
  font-family: Inter !important;
}

.group-project-name{
  font-size: 14px;
  font-weight: 500;
  line-height: 16.94px;
  letter-spacing: 0.01px;
  color: #03030A;
  font-family: Inter;
}

table .file-viewer-bodyColumn{
  font-size: 12px !important;
  font-weight: 400 !important;
  line-height: 14.52px !important;
  letter-spacing: 0.01px !important;
  color: #03030A !important;
  font-family: Inter !important;
}
.hod-Project{
  border: 1px solid #EAEAEA;
  border-radius: 8px;
}
.icon img{
  width: 100%;
}
/* react calender */
/* 
.react-calendar__navigation{
  border-bottom: 3px solid green;
  justify-content: center;
}
.react-calendar__month-view__weekdays__weekday{
  padding: 10px !important;
}
.react-calendar{
  border: 1px solid transparent !important;
}
.react-calendar__month-view__days{
  border: 1px solid #EAEAEA !important;
}
.react-calendar__month-view__days button{
  border: 1px solid #EAEAEA !important;
}
.react-calendar__tile--now{
  background-color: transparent !important;
}
.react-calendar__tile--now abbr{
  background-color: yellow;
  padding: 10px;
  border-radius: 50%;
}
.react-calendar__navigation__label{
  text-align: center;
  align-items: center;
  justify-content: center !important;
  flex-grow: inherit !important;
}
.react-calendar__navigation__arrow, .react-calendar__navigation__next-button{
  text-align: center;
  align-items: center;
  justify-content: center !important;
  border: 0;
}
.react-calendar__tile--now:enabled:hover, .react-calendar__tile--now:enabled:focus{
  background-color: transparent !important;
}
.react-calendar button{
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}
.react-calendar button ul{
  padding-left: 0px;
  text-align: left;
}
abbr{
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  display: block;
  margin: 0 auto;
  text-decoration: none;
}
.event-circle{
  list-style-type: circle;
  list-style-position: inside;
  color: blue;
  font-size: 12px;
}
.event-text{
  color: #000;
}
.more_btn{
  font-size: 12px;
  font-weight: 700;
  color: #000;
}
.react-calendar__month-view__days__day--weekend{}
.event-pop li{
  padding: 3px;
}
.event-pop li:hover{
  background: yellow;
}
.react-calendar__tile {
    height: 100px;
}
.p-overlaypanel .p-overlaypanel-close{
  color: #fff !important;
} */



.gt_task_name{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.month-cell {
  text-align: center;
  vertical-align: middle;
}
.week-label {
  font-size: 0.85rem;
  color: #6c757d;
}
.gt_month{
  font-size: 12px !important;
  font-weight: 500 !important;
  line-height: 14.52px !important;
  letter-spacing: 0.01px !important;
  color: #03030A !important;
  font-family: Inter !important;
}
.gt_week{
  font-size: 11px !important;
  font-weight: 500 !important;
  line-height: 13.31px !important;
  letter-spacing: 0.01px !important;
  color: #03030A !important;
  font-family: Inter !important;
}
.gt_task{
   font-size: 12px;
  font-weight: 400;
  line-height: 14.52px;
  letter-spacing: 0.01px;
  color: #03030A;
  font-family: Inter;
}
.gt_date{
  font-size: 12px;
 font-weight: 400;
 line-height: 14.52px;
 letter-spacing: 0.01px;
 color: #2D2D2D;
 font-family: Inter;
}

.email_login{
  font-size: 15px;
  font-weight: 600;
  line-height: 16.94px;
  letter-spacing: 0.01px;
  color: #014FA0;
  font-family: Inter;
  cursor: pointer;
}

.role_detail{
  font-size: 13px;
  font-weight: 400;
  line-height: 15.23px;
  letter-spacing: 0.01px;
  color: #6C757D;
  font-family: Inter;
}

.sticky-header {
  position: sticky;
  top: 60px;
  background: #FFF;
  z-index: 2;
}
.histogram-sticky{
  position: sticky;
  top: 143.5px;
  background: #FFF;
  z-index: 1;
}
.gantt-sticky {
  position: sticky;
  top: 130px;
  background: white;
  z-index: 2;
}

.gantt-table-wrapper{
  border: 1px solid #EAEAEA;
  border-radius: 8px;
}

.gantt-table {
  border-collapse: collapse;
  width: 100%;
}

.gantt-table-sticky {
  position: sticky;
  top: 0;
  z-index: 3;
  border: 1px solid #EAEAEA;
  border-bottom: 0;
  background: #F8F8F8
}

.gantt-table-sticky th{
  background: #F8F8F8
}
.gantt-value td{
  background: #FFF;
}

.gantt-table td {
  border: 1px solid #EAEAEA;
  text-align: left;
  padding: 8px;
}
.gantt-table th {
  /* Use outline Instead of border
The outline property does not get clipped by sticky positioning. */
  outline: 1px solid #EAEAEA;
  text-align: left;
  padding: 8px;
}

.gantt-table-tbody {
  width: 100%;
  height: calc(100vh - 240px);
  overflow: auto;
}

.gantt-table tr {
  padding: 10px;
}

.tr-project-name {
  color: #03030A;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.008px;
  padding: 10px;
}

.gantt-project{
  position: sticky;
  left: 0;
  border: 1px solid #EAEAEA
}
.gantt-start{
  position: sticky;
  left: 200px;
  /* border-top: 1px solid #EAEAEA; */
  outline: 1px solid #EAEAEA
}
.gantt-end{
  position: sticky;
  left: 310px;
  outline: 1px solid #EAEAEA
}


.user-proj .p-datatable .p-datatable-thead>tr>th {
  border-bottom: 1px solid #e5e7eb !important;
  padding: 16px 22px !important;
}
.user-proj .p-datatable .p-datatable-tbody>tr.p-rowgroup-header>td{
  padding: 16px 16px !important;
}
.user-proj .p-datatable .p-datatable-tbody>tr>td {
  padding: 16px 25px !important;
}
.img-logo {
  display: flex;
  align-items: center;
  justify-content: center;
}
.upld-img-txt {
  text-align: center;
  padding-top: 10px;
}
.project_upload_image{
  color: #4B4B4B;
  font-size: 12px;
  font-weight: 400px;
}
.browse_image{
  color: #03030A;
  font-size: 13px;
  font-weight: 400px;
}
.disabled-row {
  background-color: white;
  opacity: 0.5;
}
.hold-projects-disabled-row {
  pointer-events: none;
  cursor: not-allowed;
  background-color: white;
  opacity: 0.3;
}
.header-dropdown{
  border: none !important;
  background-color: transparent;
  font-size: 15px;
  font-weight: 500;
  line-height: 16.94px;
  color: #014FA0;
}
.header-dropdown:hover{
  background-color: transparent !important;
  color: #014FA0 !important;
  border: none !important;
  box-shadow: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,4CAAkD;AACpD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,sBAAsB;AACxB;;;;AAIA;EACE,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;AACpB;;;;;AAKA;EACE,4BAA4B;;AAE9B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,6BAA6B;EAC7B,yBAAyB;EACzB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,mDAA2C;EAC3C,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,4BAA4B;EAC5B,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,kDAAkD;EAClD,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;;;;AAKA;EACE,aAAa;EACb,mBAAmB;AACrB;;;;AAIA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,qCAAqC;;AAEvC;;;AAGA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,qCAAqC;;AAEvC;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;;;;AAKA;EACE,WAAW;EACX,yDAAiD;EACjD,4BAA4B;EAC5B,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,yDAAiD;EACjD,4BAA4B;EAC5B,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,yDAAiD;EACjD,4BAA4B;EAC5B,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,yDAAiD;EACjD,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,yDAAuD;EACvD,4BAA4B;EAC5B,0BAA0B;EAC1B,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,yDAAuD;EACvD,4BAA4B;EAC5B,0BAA0B;EAC1B,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,yDAAuD;EACvD,4BAA4B;EAC5B,0BAA0B;EAC1B,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,yDAAuD;EACvD,4BAA4B;EAC5B,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;;;;;;;;;;;;;;GAcG;;AAEH;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;AACA;;GAEG;;AAEH;EACE,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,yBAAyB;EACzB,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,+BAA+B;EAC/B,iCAAiC;EACjC,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;EACvB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;;;AAIA,qBAAqB;AACrB;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,uBAAkB;EAAlB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,uBAAkB;EAAlB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;AAEF;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,iBAAiB;;EAEjB;AACF;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA,oCAAoC;AACpC;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;EAEE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sCAAsC;EACtC,gBAAgB;EAChB,cAAc;;AAEhB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;EAClB,cAAc;AAChB;;AAEA,oCAAoC;AACpC;EACE,yBAAyB;EACzB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,0DAAwC;EACxC,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;EAC/B,0DAA0C;EAC1C,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;EAC/B,0DAA6C;EAC7C,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;EAC/B,0DAA8C;EAC9C,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sCAAsC;EACtC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sCAAsC;EACtC,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,kBAAkB;AACpB;;;AAGA;EACE,yBAAyB;AAC3B;AACA,mCAAmC;AACnC;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB,EAAE,uCAAuC;EAClE,WAAW,EAAE,iCAAiC;AAChD;;AAEA;EACE,yBAAyB,EAAE,kCAAkC;EAC7D,WAAW,EAAE,4BAA4B;EACzC,yBAAyB,EAAE,wBAAwB;AACrD;;AAEA;EACE,yBAAyB,EAAE,2CAA2C;AACxE;;AAEA,oCAAoC;AACpC;EACE,eAAe;;EAEf,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;AACA,YAAY;AACZ;EACE;6BAC2B;EAC3B,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,cAAc;AAChB,kBAAkB;AAClB,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,mBAAmB;AACnB,uBAAuB;AACvB,WAAW;AACX;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,6BAA6B;AAC/B;AACA,oCAAoC;;AAEpC,qCAAqC;;;AAGrC;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,6BAA6B;EAC7B,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE;MACI,sBAAsB,EAAE,8BAA8B;EAC1D;EACA;IACE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,+BAA+B;EAC/B,iCAAiC;EACjC,yBAAyB;EACzB,6BAA6B;AAC/B;AACA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,+BAA+B;EAC/B,iCAAiC;EACjC,yBAAyB;EACzB,6BAA6B;AAC/B;AACA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,+BAA+B;EAC/B,iCAAiC;EACjC,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,+BAA+B;EAC/B,iCAAiC;EACjC,yBAAyB;EACzB,6BAA6B;AAC/B;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA,mBAAmB;AACnB;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAmFG;;;;AAIH;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,+BAA+B;EAC/B,iCAAiC;EACjC,yBAAyB;EACzB,6BAA6B;AAC/B;AACA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,+BAA+B;EAC/B,iCAAiC;EACjC,yBAAyB;EACzB,6BAA6B;AAC/B;AACA;GACG,eAAe;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;CAChB,gBAAgB;CAChB,oBAAoB;CACpB,sBAAsB;CACtB,cAAc;CACd,kBAAkB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,yBAAyB;EACzB,gBAAgB;EAChB;AACF;;AAEA;EACE;AACF;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE;kEACgE;EAChE,0BAA0B;EAC1B,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,OAAO;EACP;AACF;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,mCAAmC;EACnC;AACF;AACA;EACE,gBAAgB;EAChB,WAAW;EACX;AACF;;;AAGA;EACE,2CAA2C;EAC3C,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,wCAAwC;EACxC,yBAAyB;EACzB,uBAAuB;EACvB,2BAA2B;AAC7B","sourcesContent":["@font-face {\n  font-family: Inter;\n  src: url(./font/Inter-VariableFont_slnt\\,wght.ttf);\n}\n\n.ds-dropdown {\n  background: #475BE8;\n}\n\n.btn {\n  color: #fff;\n}\n\n.ps-heading {\n  color: #292929;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 131.9%;\n}\n\n.ps-project-name {\n  color: #525252;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 131.9%;\n}\n\n.nav-logo {\n  color: white;\n  font-size: 22px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 131.9%;\n}\n\n/* the Gantt chart bar label */\n._3zRJQ {\n  font-size: 0px !important;\n}\n._WuQ0f:first-child{\n  padding-left: 10px;\n}\n._nI1Xw div{\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.task_name{\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  width: 200px !important;\n}\n\n.login_container {\n  display: flex;\n  height: 100vh;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  /* overflow: hidden; */\n}\n\n\n\n.head {\n  color: #03030A;\n  font-size: 24px !important;\n  font-weight: 600;\n  font-family: Inter;\n}\n\n\n\n\n.content {\n  padding-top: 17px !important;\n\n}\n\n.text-900 {\n  font-size: 13px !important;\n  font-weight: 500 !important;\n  font-family: Inter !important;\n}\n\n.text-800 {\n  font-size: 13px !important;\n  font-weight: 500 !important;\n  font-family: Inter !important;\n  color: #03030A !important;\n  line-height: 15.73px;\n  letter-spacing: 0.01px;\n}\n\n.l-forget-text {\n  font-family: Inter !important;\n  font-family: 500 !important;\n  font-size: 12px !important;\n  color: #03030A !important;\n}\n\n.ls-admin_bg {\n  background: url(./images/RectangleCopy.png);\n  width: 100%;\n  height: 100%;\n  /* padding: 47px 0 47px 88px; */\n  background-repeat: no-repeat;\n  background-size: cover !important;\n  border-radius: 12px;\n}\n\n.ls-yellow_bg {\n  /* background: url(./images/RectangleColor.png); */\n  width: 100%;\n  height: 100%;\n}\n\n.ls-text {\n  color: #03030A;\n  font-family: Inter;\n  font-size: 44px;\n  font-weight: 300;\n  font-style: normal;\n  line-height: 56px;\n  /* 127.273% */\n  letter-spacing: 0.44px;\n}\n\n.ls-subtext {\n  color: #03030A;\n  font-family: Inter;\n  font-size: 44px;\n  font-weight: 600;\n  font-style: normal;\n  line-height: 56px;\n  /* 127.273% */\n  letter-spacing: 0.44px;\n}\n\n\n\n\n.field {\n  display: flex;\n  align-items: center;\n}\n\n\n\n.register .input_field {\n  height: 35px;\n}\n\n.error_msg p {\n  color: #bf1650;\n  font-size: 10px;\n  font-weight: 500;\n  margin: -8px 0 1rem 0;\n  line-height: 1.5;\n  font-family: AppleSDGothicNeo-Regular;\n\n}\n\n\n.login_error_msg p {\n  color: #E40000;\n  font-size: 12px;\n  font-weight: 500;\n  margin: -8px 0 1rem 0;\n  line-height: 14.52px;\n  font-family: AppleSDGothicNeo-Regular;\n\n}\n\n.error_msg p::before {\n  display: inline;\n  content: \"⚠ \";\n}\n\n.error_msg_RA {\n  color: #bf1650;\n  font-size: 10px;\n  font-weight: 500;\n  padding-top: 10px;\n}\n\n.error_msg_RA::before {\n  display: inline;\n  content: \"⚠ \";\n}\n\n\n\n\n.hod-dash-image{\n  width: 100%;\n  background-image: url(./images/HodDashboard1.svg);\n  background-repeat: no-repeat;\n  background-position: right;\n}\n.hod-dash2-image{\n  width: 100%;\n  background-image: url(./images/HodDashboard2.svg);\n  background-repeat: no-repeat;\n  background-position: right;\n}\n.hod-dash3-image{\n  width: 100%;\n  background-image: url(./images/HodDashboard3.svg);\n  background-repeat: no-repeat;\n  background-position: right;\n}\n.hod-dash4-image{\n  width: 100%;\n  background-image: url(./images/HodDashboard4.svg);\n  background-repeat: no-repeat;\n  background-position: right;\n}\n\n.admin-dash-image{\n  width: 100%;\n  background-image: url(./images/AdminDashboardLogo1.svg);\n  background-repeat: no-repeat;\n  background-position: right;\n  background-size: cover;\n}\n.admin-dash2-image{\n  width: 100%;\n  background-image: url(./images/AdminDashboardLogo2.svg);\n  background-repeat: no-repeat;\n  background-position: right;\n  background-size: cover;\n}\n.admin-dash3-image{\n  width: 100%;\n  background-image: url(./images/AdminDashboardLogo3.svg);\n  background-repeat: no-repeat;\n  background-position: right;\n  background-size: cover;\n}\n.admin-dash4-image{\n  width: 100%;\n  background-image: url(./images/AdminDashboardLogo4.svg);\n  background-repeat: no-repeat;\n  background-position: right;\n  background-size: cover;\n}\n\n/* .admin-dash1-image{\n  width: 100%;\n  background-image: url(./images/projects/admindash1.png);\n  background-repeat: no-repeat; \n  background-size: contain;\n  flex: 1;\n  min-height: 100px;\n}\n.dash-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center; \n  gap: 1rem; \n  height: auto;\n} */\n\n.p-dropdown .p-dropdown-label.p-placeholder {\n  color: #4b5563;\n  font-size: 1rem;\n}\n\n.login-btn {\n  color: #FFFFFF;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 131.9%;\n  border-radius: 5px;\n  background: #014FA0;\n  padding: 10px;\n  border: 1px solid #014FA0;\n}\n/* .p-button :hover{\n  color: #FFFFFF !important;\n} */\n\n.eye-icon-position {\n  top: 9px;\n  right: 12px;\n}\n\n.card {\n  background: var(--surface-card);\n  border-radius: 8px;\n  border: 1px solid #EAEAEA;\n  background: #FFF;\n  box-shadow: 0 0 0 0 !important;\n  padding: 1rem;\n}\n\n.dashboard-card {\n  background: var(--surface-card);\n  border-radius: 8px;\n  border: 1px solid #EAEAEA;\n  background: rgb(248, 248, 248);\n  box-shadow: 0 0 0 0;\n  padding: 4px;\n  margin-bottom: 10px;\n}\n\n.card-title {\n  background: #F8F8F8;\n}\n\n.card-heading {\n  color: #03030A;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: 0.008px;\n}\n\n.user-attachment{\n  font-size: 14px; \n  font-weight: 600;\n  color: #03030A;\n  line-height: 16.94px;\n  letter-spacing: 0.01px;\n  font-family: Inter;\n}\n.file-upload-size{\n  font-size: 12px; \n  font-weight: 400;\n  color: #03030A;\n  line-height: 14.52px;\n  letter-spacing: 0.01px;\n  font-family: Inter;\n}\n\n.upload-text{\n  font-size: 13px !important; \n  font-weight: 400 !important;\n  color: #03030A !important;\n  line-height: 15.73px !important;\n  letter-spacing: 0.01px !important;\n  font-family: Inter !important;\n}\n.btn-yellow {\n  border-radius: 5px;\n  border: 1px solid #014FA0;\n  background: #014FA0;\n  color: #FFFFFF;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 16.94px;\n  letter-spacing: 0.009px;\n  padding: 9px 12px;\n  opacity: 1;\n}\n\n.btn-yellow:hover, .btn-clear:hover{\n  border: solid 1px #014FA0;\n  background-color: #014FA0 !important;\n  color: #ffffff !important;\n}\n\n.btn-clear {\n  border-radius: 5px;\n  border: 1px solid #014FA0;\n  background: #014FA0;\n  color: #FFFFFF;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: 0.009px;\n  padding: 9px 11px;\n}\n\n.btn-black-user {\n  border-radius: 5px;\n  border: 1px solid #014FA0;\n  background: #014FA0;\n  color: #FFFFFF;\n  font-family: Inter;\n  font-size: 13px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 15.73px;\n  letter-spacing: 0.01px;\n  padding: 6px 10px;\n  height: 28px;\n}\n\n.btn-yellow-user {\n  border-radius: 5px;\n  border: 1px solid #014FA0;\n  background: #014FA0;\n  color: #FFFFFF;\n  font-family: Inter;\n  font-size: 13px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 15.73px;\n  letter-spacing: 0.01px;\n  padding: 6px 10px;\n  height: 29px;\n}\n\n.task-status {\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  letter-spacing: 0.007px;\n  padding: 5px 8px;\n  border-radius: 5px;\n  border: 1px solid transparent;\n}\n\n.master-tab-inner {\n  padding: 11px 12px 13px;\n  background: #F3F3F3;\n  border: 1px solid #F3F3F3;\n  border-radius: 5px;\n  margin-bottom: 20px;\n}\n\n.table-wrapper {\n  border-radius: 8px !important;\n  border: 1px solid #EAEAEA;\n  background: #FFFFFF;\n}\n\n.header-list {\n  color: #03030A;\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  letter-spacing: 0.007px;\n}\n\n.lr-gap .field:nth-child(odd) {\n  padding-right: 34px;\n}\n\n.lr-gap .field:nth-child(even) {\n  padding-left: 34px;\n}\n\n.card-hover:hover {\n  background: #F8F8F8;\n}\n\n\n\n/* comments section */\n.text-13-500 {\n  color: #03030A;\n  font-family: Inter;\n  font-size: 13px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 15.73px;\n  letter-spacing: 0.01px;\n}\n\n.text-12-400 {\n  color: #03030A;\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  letter-spacing: 0.007px;\n}\n\n.comment-lefttext-bg {\n  background-color: #F8F8F8;\n  padding: 12px 18px;\n  width: fit-content;\n  position: relative;\n  margin-right: 20px;\n}\n\n.comment-lefttext-bg::after {\n  content: \"\";\n  position: absolute;\n  right: -20px;\n  bottom: 0;\n  width: 0;\n  height: 0;\n  border-left: 20px solid #F8F8F8;\n  border-top: 20px solid transparent;\n  border-bottom: 20px solid transparent;\n}\n\n.comment-righttext-bg {\n  background-color: #F8F8F8;\n  padding: 12px 18px;\n  width: fit-content;\n  position: relative;\n  margin-left: 20px;\n}\n\n.comment-righttext-bg::before {\n  content: \"\";\n  position: absolute;\n  left: -20px;\n  bottom: 0;\n  width: 0;\n  height: 0;\n  border-right: 20px solid #F8F8F8;\n  border-top: 20px solid transparent;\n  border-bottom: 20px solid transparent;\n}\n\n.comment-input {\n  background-color: #F8F8F8;\n}\n\n\n@media (max-width: 770px) {\n  .lr-gap .field:nth-child(odd) {\n    padding: 0;\n  }\n\n  .lr-gap .field:nth-child(even) {\n    padding: 0;\n  }\n\n}\n.small-cards{\n  margin: 18px 0 18px 23px;\n}\n.small-text{\n  margin: auto;\n  margin-left: 14px;\n\n  }\n.attendance-download-position {\n  position: relative;\n}\n\n.attendance-download-btn-position {\n  position: absolute;\n  top: -120px;\n  right: 8px;\n}\n\n/* Add this CSS to your stylesheet */\n.skill-matrix-table .table-container {\n  width: 100%;\n  overflow-x: auto;\n}\n\n.skill-matrix-table table {\n  width: 100%;\n  border-collapse: collapse;\n  border: 1px solid #EAEAEA;\n}\n\n.skill-matrix-table table th,\n.skill-matrix-table table td {\n  padding: 8px;\n  border: 1px solid #EAEAEA;\n  font-family: Inter;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 16px;\n  letter-spacing: 0.007389103528112173px;\n  text-align: left;\n  color: #03030A;\n\n}\n\n.skill-matrix-table table td {\n  border-width: 0px 0px;\n  text-align: center;\n  padding: 16px;\n}\n\n.skill-matrix-table table tbody tr {\n  border-width: 1px 0px;\n  border: 1px solid #EAEAEA;\n}\n\n.skill-matrix-table table th {\n  text-align: center;\n  background-color: #F8F8F8;\n  font-family: Inter;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 25px;\n  letter-spacing: 0.00862062070518732px;\n  text-align: center;\n  color: #03030A;\n}\n\n/* Add this CSS to your stylesheet */\n.txt-vertical {\n  writing-mode: vertical-rl;\n  text-orientation: mixed;\n  padding: 8px;\n}\n\n.txt-vertical h4 {\n  margin: 0;\n  transform: rotate(-180deg);\n  transform-origin: center;\n  font-size: 13px;\n  font-weight: 400;\n}\n\n.level-1 {\n  /* color: #F3C3FF !important; */\n  background-image: url(./images/pink.png);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n}\n\n.level-2 {\n  /* color: #CDC3FF !important; */\n  background-image: url(./images/purple.png);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n}\n\n.level-3 {\n  /* color: #AAC9FF !important; */\n  background-image: url(./images/blue-star.png);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n}\n\n.level-4 {\n  /* color: #CDF463 !important; */\n  background-image: url(./images/green-star.png);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n}\n\n.fsv-label {\n  font-family: Inter;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 16px;\n  letter-spacing: 0.007389103528112173px;\n  text-align: left;\n  color: #03030A;\n}\n\n.fsv-value {\n  background-color: #F8F8F8;\n  font-family: Inter;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 20px;\n  letter-spacing: 0.007389103528112173px;\n  text-align: left;\n  color: #03030A;\n  padding: 10px;\n  border-radius: 5px;\n}\n\n\n.event-day {\n  background-color: #ffc107;\n}\n/* Custom styles for FullCalendar */\n.fc .fc-toolbar-title{\n  font-size: 16px;\n}\n.fc-scrollgrid-sync-inner{\n  padding: 5px 0;\n}\n.fc-dayGridMonth-view .fc-day-header {\n  background-color: #f0f0f0; /* Change day header background color */\n  color: #333; /* Change day header text color */\n}\n\n.fc-dayGrid-event {\n  background-color: #007bff; /* Change event background color */\n  color: #fff; /* Change event text color */\n  border: 1px solid #007bff; /* Add border to event */\n}\n\n.fc-dayGrid-event:hover {\n  background-color: #0056b3; /* Change event background color on hover */\n}\n\n/* Custom styles for event content */\n.PS-card-key {\n  cursor: pointer;\n\n  word-wrap: break-word;\n  text-wrap: wrap;\n  padding: 3px 7px;\n}\n.fc-h-event{}\n.fc-daygrid-event{\n  /* border: yellow;\n  background-color: yellow; */\n  /* margin: 3px 0; */\n  border: 0;\n}\n.EC-card-key h4{\n  color: #03030A;\nfont-family: Inter;\nfont-size: 14px;\nfont-style: normal;\nfont-weight: 500;\nline-height: normal;\nletter-spacing: 0.007px;\nwidth: 100%;\n}\n.fc-direction-ltr .fc-daygrid-event.fc-event-end, .fc-direction-rtl .fc-daygrid-event.fc-event-start{\n  margin-left: 0;\n  margin-right: 0;\n}\n.fc-direction-ltr .fc-daygrid-event.fc-event-start, .fc-direction-rtl .fc-daygrid-event.fc-event-end{\n  margin-left: 0;\n  margin-right: 0;\n}\n.fc-daygrid-dot-event{\n  padding: 0px;\n}\n.fc-daygrid-dot-event.fc-event-mirror, .fc-daygrid-dot-event:hover{\n  background-color: transparent;\n}\n.fc-event-selected, .fc-event:focus{}\n\n/* Add more custom styles as needed */\n\n\n.d-status .p-dropdown-label.p-placeholder{\n  color: black !important;\n}\n\n.toggle-switch {\n  display: flex;\n  background-color: #323232;\n  padding: 2px;\n  border-radius: 5px;\n}\n\n.toggle-button {\n  padding: 5px 10px;\n  border: 1px solid transparent;\n  background-color: transparent;\n  cursor: pointer;\n  color: #fff;\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 16px;\n  letter-spacing: 0.00862062070518732px;\n}\n\n.toggle-button.active {\n  background-color: #E6FB2D;\n  border-radius: 5px;\n  color: #323232;\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 16px;\n  letter-spacing: 0.00862062070518732px;\n}\n\n.flex-container {\n  display: flex;\n  gap: 1rem;\n  width: 100%;\n}\n\n.p-datatable {\n  position: relative;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px !important;\n}\n\n@media (max-width: 768px) {\n  .flex-container {\n      flex-direction: column; /* Stack elements vertically */\n  }\n  .project_search{\n    display: flex;\n    margin-top: 15px;\n  }\n  .Pro{\n    flex-direction: column;\n  }\n}\n\n.user-dashboard img{\n  width: 100%;\n  height: 100%;\n}\n.user-dashboard-title{\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 19.36px;\n  letter-spacing: 0.01px;\n  color: #03030A;\n  font-family: Inter;\n}\n\ntable .user-project-header{\n  font-size: 15px !important;\n  font-weight: 500 !important;\n  line-height: 18.15px !important;\n  letter-spacing: 0.01px !important;\n  color: #03030A !important;\n  font-family: Inter !important;\n}\ntable .user-project-bodyColumn{\n  font-size: 12px !important;\n  font-weight: 400 !important;\n  line-height: 14.52px !important;\n  letter-spacing: 0.01px !important;\n  color: #03030A !important;\n  font-family: Inter !important;\n}\ntable .admin-project-bodyColumn{\n  font-size: 13px !important;\n  font-weight: 700 !important;\n  line-height: 15.73px !important;\n  letter-spacing: 0.01px !important;\n  color: #03030A !important;\n  font-family: Inter !important;\n}\n\n.group-project-name{\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 16.94px;\n  letter-spacing: 0.01px;\n  color: #03030A;\n  font-family: Inter;\n}\n\ntable .file-viewer-bodyColumn{\n  font-size: 12px !important;\n  font-weight: 400 !important;\n  line-height: 14.52px !important;\n  letter-spacing: 0.01px !important;\n  color: #03030A !important;\n  font-family: Inter !important;\n}\n.hod-Project{\n  border: 1px solid #EAEAEA;\n  border-radius: 8px;\n}\n.icon img{\n  width: 100%;\n}\n/* react calender */\n/* \n.react-calendar__navigation{\n  border-bottom: 3px solid green;\n  justify-content: center;\n}\n.react-calendar__month-view__weekdays__weekday{\n  padding: 10px !important;\n}\n.react-calendar{\n  border: 1px solid transparent !important;\n}\n.react-calendar__month-view__days{\n  border: 1px solid #EAEAEA !important;\n}\n.react-calendar__month-view__days button{\n  border: 1px solid #EAEAEA !important;\n}\n.react-calendar__tile--now{\n  background-color: transparent !important;\n}\n.react-calendar__tile--now abbr{\n  background-color: yellow;\n  padding: 10px;\n  border-radius: 50%;\n}\n.react-calendar__navigation__label{\n  text-align: center;\n  align-items: center;\n  justify-content: center !important;\n  flex-grow: inherit !important;\n}\n.react-calendar__navigation__arrow, .react-calendar__navigation__next-button{\n  text-align: center;\n  align-items: center;\n  justify-content: center !important;\n  border: 0;\n}\n.react-calendar__tile--now:enabled:hover, .react-calendar__tile--now:enabled:focus{\n  background-color: transparent !important;\n}\n.react-calendar button{\n  display: flex;\n  justify-content: flex-start;\n  flex-direction: column;\n}\n.react-calendar button ul{\n  padding-left: 0px;\n  text-align: left;\n}\nabbr{\n  text-align: center;\n  font-size: 12px;\n  font-weight: 500;\n  display: block;\n  margin: 0 auto;\n  text-decoration: none;\n}\n.event-circle{\n  list-style-type: circle;\n  list-style-position: inside;\n  color: blue;\n  font-size: 12px;\n}\n.event-text{\n  color: #000;\n}\n.more_btn{\n  font-size: 12px;\n  font-weight: 700;\n  color: #000;\n}\n.react-calendar__month-view__days__day--weekend{}\n.event-pop li{\n  padding: 3px;\n}\n.event-pop li:hover{\n  background: yellow;\n}\n.react-calendar__tile {\n    height: 100px;\n}\n.p-overlaypanel .p-overlaypanel-close{\n  color: #fff !important;\n} */\n\n\n\n.gt_task_name{\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.month-cell {\n  text-align: center;\n  vertical-align: middle;\n}\n.week-label {\n  font-size: 0.85rem;\n  color: #6c757d;\n}\n.gt_month{\n  font-size: 12px !important;\n  font-weight: 500 !important;\n  line-height: 14.52px !important;\n  letter-spacing: 0.01px !important;\n  color: #03030A !important;\n  font-family: Inter !important;\n}\n.gt_week{\n  font-size: 11px !important;\n  font-weight: 500 !important;\n  line-height: 13.31px !important;\n  letter-spacing: 0.01px !important;\n  color: #03030A !important;\n  font-family: Inter !important;\n}\n.gt_task{\n   font-size: 12px;\n  font-weight: 400;\n  line-height: 14.52px;\n  letter-spacing: 0.01px;\n  color: #03030A;\n  font-family: Inter;\n}\n.gt_date{\n  font-size: 12px;\n font-weight: 400;\n line-height: 14.52px;\n letter-spacing: 0.01px;\n color: #2D2D2D;\n font-family: Inter;\n}\n\n.email_login{\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 16.94px;\n  letter-spacing: 0.01px;\n  color: #014FA0;\n  font-family: Inter;\n  cursor: pointer;\n}\n\n.role_detail{\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 15.23px;\n  letter-spacing: 0.01px;\n  color: #6C757D;\n  font-family: Inter;\n}\n\n.sticky-header {\n  position: sticky;\n  top: 60px;\n  background: #FFF;\n  z-index: 2;\n}\n.histogram-sticky{\n  position: sticky;\n  top: 143.5px;\n  background: #FFF;\n  z-index: 1;\n}\n.gantt-sticky {\n  position: sticky;\n  top: 130px;\n  background: white;\n  z-index: 2;\n}\n\n.gantt-table-wrapper{\n  border: 1px solid #EAEAEA;\n  border-radius: 8px;\n}\n\n.gantt-table {\n  border-collapse: collapse;\n  width: 100%;\n}\n\n.gantt-table-sticky {\n  position: sticky;\n  top: 0;\n  z-index: 3;\n  border: 1px solid #EAEAEA;\n  border-bottom: 0;\n  background: #F8F8F8\n}\n\n.gantt-table-sticky th{\n  background: #F8F8F8\n}\n.gantt-value td{\n  background: #FFF;\n}\n\n.gantt-table td {\n  border: 1px solid #EAEAEA;\n  text-align: left;\n  padding: 8px;\n}\n.gantt-table th {\n  /* Use outline Instead of border\nThe outline property does not get clipped by sticky positioning. */\n  outline: 1px solid #EAEAEA;\n  text-align: left;\n  padding: 8px;\n}\n\n.gantt-table-tbody {\n  width: 100%;\n  height: calc(100vh - 240px);\n  overflow: auto;\n}\n\n.gantt-table tr {\n  padding: 10px;\n}\n\n.tr-project-name {\n  color: #03030A;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: 0.008px;\n  padding: 10px;\n}\n\n.gantt-project{\n  position: sticky;\n  left: 0;\n  border: 1px solid #EAEAEA\n}\n.gantt-start{\n  position: sticky;\n  left: 200px;\n  /* border-top: 1px solid #EAEAEA; */\n  outline: 1px solid #EAEAEA\n}\n.gantt-end{\n  position: sticky;\n  left: 310px;\n  outline: 1px solid #EAEAEA\n}\n\n\n.user-proj .p-datatable .p-datatable-thead>tr>th {\n  border-bottom: 1px solid #e5e7eb !important;\n  padding: 16px 22px !important;\n}\n.user-proj .p-datatable .p-datatable-tbody>tr.p-rowgroup-header>td{\n  padding: 16px 16px !important;\n}\n.user-proj .p-datatable .p-datatable-tbody>tr>td {\n  padding: 16px 25px !important;\n}\n.img-logo {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.upld-img-txt {\n  text-align: center;\n  padding-top: 10px;\n}\n.project_upload_image{\n  color: #4B4B4B;\n  font-size: 12px;\n  font-weight: 400px;\n}\n.browse_image{\n  color: #03030A;\n  font-size: 13px;\n  font-weight: 400px;\n}\n.disabled-row {\n  background-color: white;\n  opacity: 0.5;\n}\n.hold-projects-disabled-row {\n  pointer-events: none;\n  cursor: not-allowed;\n  background-color: white;\n  opacity: 0.3;\n}\n.header-dropdown{\n  border: none !important;\n  background-color: transparent;\n  font-size: 15px;\n  font-weight: 500;\n  line-height: 16.94px;\n  color: #014FA0;\n}\n.header-dropdown:hover{\n  background-color: transparent !important;\n  color: #014FA0 !important;\n  border: none !important;\n  box-shadow: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
